import React, { SyntheticEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";

import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Button,
  Tabs,
  Tab,
} from "@mui/material";

import { GridColDef } from "@mui/x-data-grid";
import SearchBar from "../../components/SearchBar";

import {
  useLazyDeleteQueryQuery,
  useQueryListMutation,
  useRevertQueryMutation,
} from "../../service/customerSupport";

import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody, CustomerSupportResponse } from "../../types/General";
import { errorToast, successToast } from "../../helpers";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import { isValidInput } from "../../utils/validations";
import { RevertModal } from "../../Modals/revertModal";
import moment from "moment";
import NewIndividualsList from "../../features/individuals/NewIndividuals";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const CustomerSupport = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [openRevert, setOpenRevert] = useState(false);
  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [revert, setRevert] = useState("");
  const [error, setError] = useState(false);
  const [selectedRow, setSelectedRow] =
    useState<CustomerSupportResponse | null>(null);

  const [selectedId, setSelectedId] = useState<number | null>(null);

  const [rows, setRows] = useState<CustomerSupportResponse[]>([]);
  const [valueTabs, setValueTabs] = useState(0);

  const [queriesList] = useQueryListMutation();
  const [deleteQuery] = useLazyDeleteQueryQuery();
  const [revertQuery] = useRevertQueryMutation();

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };
  const handleChangeTabs = (event: SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const getQueriesList = async () => {
    setLoading(true);
    try {
      const body = {
        start: page,
        length: 10,
        search: debouncedSearchTerm.trim(),
        type: valueTabs === 0 ? 1 : 2,
      };

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await queriesList(encryptedBody).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        setRows(response?.data?.response_object || []);
        setCount(response?.data?.total_records);
      } else {
        setRows([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };
  const handleSubmit = async () => {
    setError(true);
    if (!revert?.length) {
      return;
    }
    setLoading(true);

    try {
      const body = {
        answer: revert,
      };

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await revertQuery({
        body: encryptedBody,
        id: selectedId,
      }).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        setOpenRevert(false);
        setError(false);
        setRevert("");
        successToast("Revert sent successfully");
        getQueriesList();
      } else {
        setRows([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      const response = await deleteQuery({
        id: selectedId,
      }).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        successToast("Deleted successfully");
        getQueriesList();
      } else {
        setRows([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);

  const handleClick1 = (
    event: React.MouseEvent<HTMLButtonElement>,
    row: CustomerSupportResponse
  ) => {
    setAnchorEl1(event.currentTarget);
    setSelectedId(row?.id);
    setSelectedRow(row);
  };

  const handleClose1 = () => {
    setAnchorEl1(null);
    setSelectedId(null);
    setSelectedRow(null);
  };

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 250,
      field: "name",
      headerName: "User Details",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure
              onClick={() => navigate(`/users/individual/${row?.userid}`)}
            >
              <img
                src={
                  row?.profile_picture?.media_url ||
                  "/static/images/user_placeholder.png"
                }
                alt=""
              />
            </figure>
            <p>
              <b>
                {row?.first_name || "-"} {row?.middle_name || ""}{" "}
                {row?.last_name || ""}
              </b>{" "}
              {row?.country_code} {row?.phone_no || "-"} <br />
              {row?.email || "-"}
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "date",
      headerName: "Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>
              {row?.created_at
                ? moment(row?.created_at).format("DD MMM YYYY")
                : "-"}
            </p>
          </div>
        );
      },
    },
    ...(valueTabs === 0
      ? [
          {
            flex: 1,
            minWidth: 150,
            field: "query",
            headerName: "Query",
            editable: false,
            sortable: false,
            renderCell: ({ row }: any) => {
              return (
                <div className="user_block">
                  <p>
                    {row?.description?.length >= 20
                      ? row?.description?.slice(0, 20) + "..."
                      : row?.description}
                  </p>
                </div>
              );
            },
          },
        ]
      : [
          {
            flex: 1,
            minWidth: 150,
            field: "subject",
            headerName: "Subject",
            editable: false,
            sortable: false,
            renderCell: ({ row }: any) => {
              return (
                <div className="user_block">
                  <p>
                    {row?.subject?.length >= 20
                      ? row?.subject?.slice(0, 20) + "..."
                      : row?.subject}
                  </p>
                </div>
              );
            },
          },
          {
            flex: 1,
            minWidth: 150,
            field: "query",
            headerName: "Query",
            editable: false,
            sortable: false,
            renderCell: ({ row }: any) => {
              return (
                <div className="user_block">
                  <p>
                    {row?.description?.length >= 20
                      ? row?.description?.slice(0, 20) + "..."
                      : row?.description}
                  </p>
                </div>
              );
            },
          },
        ]),

    {
      flex: 1,
      minWidth: 300,
      field: "revert",
      headerName: "Revert Message",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>
              {row?.answer?.length >= 20
                ? row?.answer?.slice(0, 20) + "..."
                : row?.answer || "-"}
            </p>
          </div>
        );
      },
    },

    {
      flex: 0.1,
      minWidth: 80,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? "basic-menu1" : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? "true" : undefined}
                onClick={(event) => handleClick1(event, row)}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  "aria-labelledby": "basic-button1",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.05)",
                    borderRadius: "8px",
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                {selectedRow?.reverted_back ? null : (
                  <MenuItem
                    onClick={() => {
                      setOpenRevert(true);
                      setAnchorEl1(null);
                    }}
                  >
                    Revert
                  </MenuItem>
                )}
                <MenuItem onClick={() => navigate(`detail/${selectedId}`)}>
                  View
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setAnchorEl1(null);
                    setOpen(true);
                  }}
                >
                  Delete
                </MenuItem>
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    getQueriesList();
  }, [page, debouncedSearchTerm, valueTabs]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Customer Support</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
          Customer Support
        </p>
      </div>
      <div className="cards">
        <Box className="custom_tabs" sx={{ width: "100%" }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  placeholder="Search"
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm("")}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
            <div className="right_s">
              <Box>
                <Button className="btn btn_highlight">
                  <img src="/static/images/upload_icon.svg" alt="Icon" /> Export
                  CSV
                </Button>
              </Box>
            </div>
          </div>

          <Tabs
            value={valueTabs}
            onChange={handleChangeTabs}
            aria-label="basic tabs example"
            className="custom_tabs_links"
          >
            <Tab label={`Customer Support`} {...a11yProps(0)} />
            <Tab label={`Email Queries`} {...a11yProps(1)} />
          </Tabs>
          <CustomTabPanel value={valueTabs} index={0}>
            <NewIndividualsList
              rows={rows}
              columns={columns}
              count={count}
              page={page}
              onPageChange={handlePageChange}
              loading={loading}
            />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={1}>
            <NewIndividualsList
              rows={rows}
              columns={columns}
              count={count}
              page={page}
              onPageChange={handlePageChange}
              loading={loading}
            />
          </CustomTabPanel>
        </Box>
        <ConfirmationModal
          text={"Are you sure to delete this query?"}
          openModal={open}
          setOpenModal={setOpen}
          handleSubmit={handleDelete}
        />
        <RevertModal
          openModal={openRevert}
          setOpenModal={setOpenRevert}
          revert={revert}
          setRevert={setRevert}
          handleSubmit={handleSubmit}
          error={error}
          setError={setError}
        />
      </div>
    </MainContainer>
  );
};

export default CustomerSupport;
